import { supabase } from '../config/supabase'; // Import Supabase client

// The old custom token functions are no longer primary for backend auth if using Supabase JWT.
// They are renamed here for clarity in case they were used for other non-backend purposes.
export const getCustomAuthToken = () => localStorage.getItem('customAuthToken_deprecated');

export const setCustomAuthToken = (token) => {
  if (token) {
    localStorage.setItem('customAuthToken_deprecated', token);
  } else {
    localStorage.removeItem('customAuthToken_deprecated');
  }
};

export const clearCustomAuthToken = () => {
  localStorage.removeItem('customAuthToken_deprecated');
};

// API request wrapper that now uses Supabase session token
export const authenticatedFetch = async (url, options = {}) => {
  let supabaseToken = null;
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) {
      console.error("authenticatedFetch: Error getting Supabase session:", error);
    }
    if (session?.access_token) {
      supabaseToken = session.access_token;
    } else {
      console.log("authenticatedFetch: No active Supabase session or access token found.");
    }
  } catch (e) {
    console.error("authenticatedFetch: Exception while getting Supabase session:", e);
  }
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (supabaseToken) {
    headers.Authorization = `Bearer ${supabaseToken}`;
    console.log("authenticatedFetch: Attaching Supabase JWT to Authorization header for URL:", url);
  } else {
    console.warn("authenticatedFetch: No Supabase JWT available. Request to protected backend route might fail for URL:", url);
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    console.error(`authenticatedFetch: Received 401 Unauthorized from ${url}. The Supabase JWT might be invalid, expired, or the backend could not validate it with the SUPABASE_JWT_SECRET.`);
    // It's generally better for the calling component to handle 401s (e.g., by using useAuth to redirect or show a message)
    // rather than a global redirect here, as the Supabase client itself handles token refresh.
    // A persistent 401 might indicate the SUPABASE_JWT_SECRET on the backend is incorrect.
  }

  return response;
};
